import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import './Admin.css';

function AdminReportSettings() {
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });
    const [activeTab, setActiveTab] = useState('hospital');

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            setLoading(true);
            const response = await api.get('/admin/report-settings');
            setSettings(response.data);
        } catch (err) {
            console.error('Error fetching settings:', err);
            setMessage({ type: 'error', text: 'ไม่สามารถโหลดการตั้งค่าได้' });
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (category, keyName, value) => {
        setSettings(prev => ({
            ...prev,
            [category]: {
                ...prev[category],
                [keyName]: {
                    ...prev[category][keyName],
                    value: value
                }
            }
        }));
    };

    const handleSave = async () => {
        setSaving(true);
        setMessage({ type: '', text: '' });

        try {
            // Convert settings to array format
            const settingsArray = [];
            Object.entries(settings).forEach(([category, items]) => {
                Object.entries(items).forEach(([keyName, data]) => {
                    settingsArray.push({
                        category,
                        key_name: keyName,
                        key_value: data.value
                    });
                });
            });

            await api.put('/admin/report-settings/bulk', { settings: settingsArray });
            setMessage({ type: 'success', text: 'บันทึกการตั้งค่าสำเร็จ' });
        } catch (err) {
            setMessage({ type: 'error', text: err.response?.data?.error || 'เกิดข้อผิดพลาด' });
        } finally {
            setSaving(false);
        }
    };

    const tabs = [
        { id: 'hospital', label: 'ข้อมูลโรงพยาบาล', icon: 'M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16m14 0H5m14 0h2m-2 0h-2m-4-4v4m-4-4v4m-4-4v4' },
        { id: '50tawi', label: 'หนังสือ 50 ทวิ', icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8' },
        { id: 'slip', label: 'สลิปเงินเดือน', icon: 'M9 17H7v-7h2m4 7h-2V7h2m4 10h-2v-4h2m2 6H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2' },
        { id: 'request', label: 'ระบบคำร้อง', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2z' }
    ];

    const getCategoryLabel = (category) => {
        const labels = {
            hospital: 'ข้อมูลโรงพยาบาล',
            '50tawi': 'การตั้งค่า 50 ทวิ',
            slip: 'การตั้งค่าสลิป',
            request: 'การตั้งค่าระบบคำร้อง'
        };
        return labels[category] || category;
    };

    const getFieldLabel = (keyName) => {
        const labels = {
            // Hospital
            name: 'ชื่อโรงพยาบาล',
            address: 'ที่อยู่',
            phone: 'เบอร์โทรศัพท์',
            tax_id: 'เลขประจำตัวผู้เสียภาษี',
            // 50 Tawi
            signer_name: 'ชื่อผู้ลงนาม',
            signer_position: 'ตำแหน่งผู้ลงนาม',
            form_number: 'เลขแบบฟอร์ม',
            address_line1: 'ที่อยู่บรรทัด 1',
            address_line2: 'ที่อยู่บรรทัด 2',
            // Slip
            header_title: 'หัวเรื่องหลัก',
            sub_title: 'หัวเรื่องรอง',
            note_text: 'ข้อความหมายเหตุ',
            disclaimer_enabled: 'เปิดใช้งานข้อความรับรอง',
            disclaimer_text: 'ข้อความรับรองความถูกต้อง',
            disclaimer_position: 'ตำแหน่งข้อความรับรอง',
            // Request
            pickup_location: 'สถานที่รับเอกสาร'
        };
        return labels[keyName] || keyName;
    };

    if (loading) {
        return (
            <div className="flex-center" style={{ padding: '60px 0' }}>
                <div className="spinner"></div>
            </div>
        );
    }

    return (
        <div className="admin-page">
            {/* Breadcrumb */}
            <div className="breadcrumb">
                <Link to="/admin">จัดการระบบ</Link>
                <span>/</span>
                <span>ตั้งค่ารายงาน</span>
            </div>

            <div className="admin-header">
                <h1>ตั้งค่ารายงาน PDF</h1>
                <p>กำหนดข้อความและข้อมูลที่แสดงในรายงานสลิปและ 50 ทวิ</p>
            </div>

            {message.text && (
                <div className={`alert alert-${message.type}`}>
                    {message.text}
                </div>
            )}

            {/* Tabs */}
            <div className="report-tabs">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`report-tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d={tab.icon} />
                        </svg>
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Settings Form */}
            <div className="steam-card">
                <div className="steam-card-header">
                    <span>{getCategoryLabel(activeTab)}</span>
                </div>
                <div className="steam-card-body">
                    {settings[activeTab] && Object.entries(settings[activeTab]).map(([keyName, data]) => (
                        <div key={keyName} className="form-group">
                            <label className="form-label">
                                {getFieldLabel(keyName)}
                                {data.description && (
                                    <span className="form-hint"> - {data.description}</span>
                                )}
                            </label>
                            {keyName === 'disclaimer_enabled' ? (
                                <div className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        id={`toggle-${keyName}`}
                                        checked={data.value === 'true'}
                                        onChange={(e) => handleChange(activeTab, keyName, e.target.checked ? 'true' : 'false')}
                                    />
                                    <label htmlFor={`toggle-${keyName}`}></label>
                                    <span className="toggle-label">{data.value === 'true' ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}</span>
                                </div>
                            ) : keyName === 'disclaimer_position' ? (
                                <select
                                    className="steam-input"
                                    value={data.value || 'footer'}
                                    onChange={(e) => handleChange(activeTab, keyName, e.target.value)}
                                >
                                    <option value="footer">ท้ายสลิป (Footer)</option>
                                    <option value="header">หัวสลิป (Header)</option>
                                    <option value="signature">ใต้ลายเซ็น</option>
                                    <option value="watermark">Watermark (มุมล่างขวา)</option>
                                </select>
                            ) : keyName === 'disclaimer_text' ? (
                                <textarea
                                    className="steam-input"
                                    value={data.value || ''}
                                    onChange={(e) => handleChange(activeTab, keyName, e.target.value)}
                                    rows="3"
                                    placeholder="กรอกข้อความรับรองความถูกต้อง เช่น เอกสารฉบับนี้ออกโดยระบบอัตโนมัติ..."
                                />
                            ) : keyName.includes('address') && keyName !== 'address_line1' ? (
                                <textarea
                                    className="steam-input"
                                    value={data.value || ''}
                                    onChange={(e) => handleChange(activeTab, keyName, e.target.value)}
                                    rows="2"
                                />
                            ) : (
                                <input
                                    type="text"
                                    className="steam-input"
                                    value={data.value || ''}
                                    onChange={(e) => handleChange(activeTab, keyName, e.target.value)}
                                />
                            )}
                        </div>
                    ))}

                    <div className="form-actions" style={{ marginTop: '24px' }}>
                        <button
                            className="steam-btn steam-btn-primary"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? (
                                <>
                                    <div className="spinner" style={{ width: 20, height: 20, borderWidth: 2 }}></div>
                                    กำลังบันทึก...
                                </>
                            ) : (
                                <>
                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                                        <polyline points="17 21 17 13 7 13 7 21"/>
                                        <polyline points="7 3 7 8 15 8"/>
                                    </svg>
                                    บันทึกการตั้งค่า
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Preview Section */}
            <div className="steam-card mt-3">
                <div className="steam-card-header">
                    <span>ตัวอย่างข้อมูลที่จะแสดงใน PDF</span>
                </div>
                <div className="steam-card-body">
                    {activeTab === 'hospital' && settings.hospital && (
                        <div className="preview-box">
                            <div className="preview-header">
                                <h3>{settings.hospital.name?.value || 'โรงพยาบาล'}</h3>
                                <p>{settings.hospital.address?.value || 'ที่อยู่'}</p>
                                <p>โทร. {settings.hospital.phone?.value || '-'}</p>
                                <p>เลขผู้เสียภาษี: {settings.hospital.tax_id?.value || '-'}</p>
                            </div>
                        </div>
                    )}

                    {activeTab === '50tawi' && settings['50tawi'] && (
                        <div className="preview-box">
                            <div className="preview-signature">
                                <p className="preview-line">ลงชื่อ ______________________ ผู้หักภาษี ณ ที่จ่าย</p>
                                <p className="preview-name">{settings['50tawi'].signer_name?.value || 'ชื่อผู้ลงนาม'}</p>
                                <p className="preview-position">{settings['50tawi'].signer_position?.value || 'ตำแหน่ง'}</p>
                            </div>
                        </div>
                    )}

                    {activeTab === 'slip' && settings.slip && (
                        <div className="preview-box">
                            <div className="preview-slip-header">
                                <h3>{settings.slip.header_title?.value || 'หัวเรื่อง'}</h3>
                                <p>{settings.slip.sub_title?.value || 'หัวเรื่องรอง'}</p>
                            </div>
                            <div className="preview-slip-note">
                                <small>{settings.slip.note_text?.value || 'หมายเหตุ'}</small>
                            </div>
                        </div>
                    )}

                    {activeTab === 'request' && settings.request && (
                        <div className="preview-box">
                            <div className="preview-request">
                                <p style={{ marginBottom: '8px', color: 'var(--steam-text-muted)' }}>ข้อความที่จะแสดงเมื่ออนุมัติคำร้อง:</p>
                                <p style={{ fontSize: '16px' }}>
                                    <strong>รับเอกสารที่:</strong> {settings.request.pickup_location?.value || 'ฝ่ายการเงิน ชั้น 2 อาคารอำนวยการ'}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <style>{`
                .report-tabs {
                    display: flex;
                    gap: 8px;
                    margin-bottom: 20px;
                    flex-wrap: wrap;
                }
                .report-tab {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    padding: 12px 20px;
                    background: var(--steam-bg-secondary);
                    border: 1px solid var(--steam-border);
                    border-radius: var(--steam-radius-md);
                    color: var(--steam-text-secondary);
                    cursor: pointer;
                    transition: all 0.2s;
                }
                .report-tab:hover {
                    background: var(--steam-bg-tertiary);
                    color: var(--steam-text-primary);
                }
                .report-tab.active {
                    background: var(--steam-accent);
                    border-color: var(--steam-accent);
                    color: white;
                }
                .form-hint {
                    font-weight: normal;
                    color: var(--steam-text-muted);
                    font-size: 12px;
                }
                .preview-box {
                    background: var(--steam-bg-secondary);
                    border: 1px dashed var(--steam-border);
                    border-radius: var(--steam-radius-md);
                    padding: 24px;
                    text-align: center;
                }
                .preview-header h3 {
                    font-size: 18px;
                    margin-bottom: 8px;
                }
                .preview-header p {
                    color: var(--steam-text-secondary);
                    margin: 4px 0;
                }
                .preview-signature {
                    text-align: center;
                }
                .preview-line {
                    margin-bottom: 8px;
                }
                .preview-name {
                    font-weight: bold;
                    font-size: 16px;
                }
                .preview-position {
                    color: var(--steam-text-secondary);
                }
                .preview-slip-header {
                    margin-bottom: 16px;
                }
                .preview-slip-header h3 {
                    font-size: 18px;
                    margin-bottom: 4px;
                }
                .preview-slip-note {
                    border-top: 1px solid var(--steam-border);
                    padding-top: 12px;
                    color: var(--steam-text-muted);
                }
                .mt-3 {
                    margin-top: 20px;
                }
            `}</style>
        </div>
    );
}

export default AdminReportSettings;
